// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2m36v","content":"RecentSearches_content__1efOT"};